import React from 'react';
import { sermons } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function SermonsSection() {
  return <section aria-labelledby="sermons-title" className="bg-teal-tint py-12 md:py-20" data-id="element-173" data-mp="ge85uv1tlibr">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-174" data-mp="bl5achdhfysx">
        <SectionHeading id="sermons-title" title={sermons.title} sub={sermons.sub} data-id="element-175" data-mp="6nwtck42m0t9" />

        <ol className="mt-8 grid grid-cols-2 gap-3 md:mt-12 md:grid-cols-3 lg:grid-cols-5" data-id="element-176" data-mp="2m1rnei89ley">
          {sermons.items.map(s => <li key={s.n} className="flex flex-col rounded-xl border border-teal-tintLine bg-white p-4 md:p-5" data-id="element-177" data-mp="3ts32blya6d02">
              <span className="font-display text-[2rem] font-extrabold leading-none text-orange md:text-[2.4rem]" data-id="element-178" data-mp="3ou1aocmsh5cz">{s.n}</span>
              <h3 className="mt-3 font-display text-[15px] font-bold leading-snug text-teal md:text-[16px]" data-id="element-179" data-mp="3jw9kbn1slraw">{s.title}</h3>
              <p className="mt-auto pt-2 text-[12.5px] font-medium text-ink/60" data-id="element-180" data-mp="1i2sf0q14x2jb">{s.ref}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}